import * as yup from 'yup';

export const createAccountCommonValidation = ({ mustAllowDataProcessing }) => ({
  dataAccessAgreement: yup.string().when([], {
    is: () => mustAllowDataProcessing,
    then: () =>
      yup.string().test('isAccepted', '', function isAccepted(value) {
        return value === 'Y';
      }),
    otherwise: () => yup.string(),
  }),
});
